import type {BdResource, BdResourceSorting} from './resource';

/**
 * Helper class for BdResource, contains general filter and sorting functions.
 */
export class BdResources {
  static filter(resource: BdResource, searchTerm: string): boolean {
    searchTerm = searchTerm.toLowerCase();
    let matchName,
      matchId = false;

    if (resource.id) {
      matchId = resource.id.toLowerCase().indexOf(searchTerm) !== -1;
    }

    if (resource.name) {
      matchName = resource.name.toLowerCase().indexOf(searchTerm) !== -1;
    }

    if (resource.labels) {
      matchName = resource.labels.some(
        (label) => label.toLowerCase().indexOf(searchTerm) !== -1,
      );
    }

    return matchName || matchId;
  }

  static sort(
    a: BdResource,
    b: BdResource,
    sorting: BdResourceSorting,
  ): number {
    const field = sorting.field;
    const aElement: any = a[field];
    const bElement: any = b[field];

    if (typeof aElement === 'string') {
      return this.sortString(aElement.toString(), bElement.toString(), sorting);
    }

    if (aElement instanceof Date) {
      return this.sortDate(new Date(aElement), new Date(bElement), sorting);
    }

    if (!bElement) {
      return -1;
    }

    if (!aElement) {
      return 1;
    }

    return aElement.toString().localeCompare(bElement.toString());
  }

  private static sortString(
    a: string,
    b: string,
    sorting: BdResourceSorting,
  ): number {
    if (!b) {
      return -1;
    }

    if (!a) {
      return 1;
    }

    if (sorting.desc) {
      return b.localeCompare(a);
    } else {
      return a.localeCompare(b);
    }
  }

  private static sortDate(
    a: Date,
    b: Date,
    sorting: BdResourceSorting,
  ): number {
    if (!b) {
      return -1;
    }

    if (!a) {
      return 1;
    }

    if (sorting.desc) {
      return b.getTime() - a.getTime();
    } else {
      return a.getTime() - b.getTime();
    }
  }
}
